jQuery(function($){
	$('.modal').on('shown.bs.modal', function () {
		$(this).find('[autofocus]').trigger('focus');
	})
})

